import PostsAdapter from './base';

export default class Reaction extends PostsAdapter {
  modelNamePlural = 'reactions';
}
